import AlertShedule from '../components/alert/alert-no-covenant'
import AlertCovenantNotExist from '../components/alert/alert-covenant-not-exist'

export default {
  AlertShedule,
  AlertCovenantNotExist
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/components.js